import { CallinScript } from "../../../powerbroker/src/CallinScript";
import { CityState, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCallinEntry extends Layout {
    citystateCurrentLocation: CityState;
    labelCallTimeTMZ: Label;
    labelCallWarning: Label;
    labelCallinDetails: Label;
    labelDispatchEmail: Label;
    labelDispatchPhone: Label;
    labelDriverInformation: Label;
    labelLabel6: Label;
    labelLabel7: Label;
    labelLabel8: Label;
    labelLabel9: Label;
    labelNextTMZ: Label;
    labelScheduledCallTime: Label;
    labelScheduledCallTimeCaption: Label;
    labelScheduledCallTimeTMZ: Label;
    layoutCallinScript: CallinScript;
    panelCallinData: Panel;
    panelCallinEntry: Panel;
    panelCallinWarning: Panel;
    panelDispatcher: Panel;
    panelDriverOne: Panel;
    panelDriverTwo: Panel;
    panelScheduledCallTime: Panel;
    sourceCallin: DataSource;
    sourceCallinStop: DataSource;
    sourceDispatch: DataSource;
    switchCallinType: Switch;
    textboxCallDateTime: Textbox;
    textboxCallinStatus: Textbox;
    textboxCurrentLocationTime: Textbox;
    textboxDispatcher: Textbox;
    textboxNextSchedCall: Textbox;
    textboxOverrideDriver2Nm: Textbox;
    textboxOverrideDriverNm: Textbox;
    textboxRemark: Textbox;
    textboxSetpointTemp: Textbox;
    textboxTemperature: Textbox;
}
